import { QARequestButtonState } from "integration/api/Deal/models";

export const getQAButtonTitle = (state?: QARequestButtonState) => {
  switch (state) {
    case QARequestButtonState.INITIAL:
      return "Got a Question? Ask Now";
    case QARequestButtonState.REGISTRATION_CONFIRMED:
      return "Q&A registration confirmed";
    case QARequestButtonState.VIEW_ANSWER:
      return "View Q&A answer";
    case QARequestButtonState.VIEW_QA_SESSION:
      return "View Q&A session";
    case QARequestButtonState.VIEW_QUESTION:
      return "View your Q&A question";
  }
};
